import type { DasStatus, FiscalFileStatus, PackageStatus } from "@cx/contracts";
import { shiftCompetence, todayInSaoPaulo, type FiscalFileKind } from "@cx/domain";
import type { Tone } from "@cx/ui";

// ===== Rótulos da contabilidade (T3.5) =====

export const FILE_STATUS_LABEL: Record<FiscalFileStatus, string> = {
  queued: "Gerando…",
  ready: "Pronto",
  failed: "Falhou",
};
export const FILE_STATUS_TONE: Record<FiscalFileStatus, Tone> = {
  queued: "info",
  ready: "success",
  failed: "danger",
};
export const PACKAGE_STATUS_LABEL: Record<PackageStatus, string> = {
  queued: "Montando…",
  ready: "Pronto",
  sending: "Enviando…",
  sent: "Enviado",
  failed: "Falhou",
};
export const PACKAGE_STATUS_TONE: Record<PackageStatus, Tone> = {
  queued: "info",
  ready: "secondary",
  sending: "info",
  sent: "success",
  failed: "danger",
};
export const DAS_STATUS_LABEL: Record<DasStatus, string> = {
  pending: "Pendente (sem código)",
  issued: "Emitido",
  paid: "Pago",
  canceled: "Cancelado",
};
export const DAS_STATUS_TONE: Record<DasStatus, Tone> = {
  pending: "warning",
  issued: "info",
  paid: "success",
  canceled: "secondary",
};

/** Finalidades por tipo de arquivo (SPED: COD_FIN; Sintegra: finalidade do registro 10). */
export const PURPOSES: Record<FiscalFileKind, { value: number; label: string }[]> = {
  sped_fiscal: [
    { value: 0, label: "Original" },
    { value: 1, label: "Substituto" },
  ],
  sped_contribuicoes: [
    { value: 0, label: "Original" },
    { value: 1, label: "Retificador" },
  ],
  sintegra: [
    { value: 1, label: "Normal" },
    { value: 2, label: "Retificação total" },
    { value: 3, label: "Retificação aditiva" },
    { value: 5, label: "Desfazimento" },
  ],
};

/** "2026-10" → "10/2026". */
export const competenceLabel = (c: string) =>
  /^\d{4}-\d{2}$/.test(c) ? `${c.slice(5)}/${c.slice(0, 4)}` : c;

/** Competências para escolher: a atual e as `n − 1` anteriores (a mais recente primeiro), nunca antes de 2023-01. */
export function competenceOptions(n = 13, today = todayInSaoPaulo()): string[] {
  const out: string[] = [];
  for (let k = 0; k < n; k++) {
    const c = shiftCompetence(today.slice(0, 7), -k);
    if (c < "2023-01") break;
    out.push(c);
  }
  return out;
}

/** Tamanho legível ("820 KB", "12,4 MB"). */
export function sizeLabel(bytes: number | null): string {
  if (bytes === null) return "—";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
}
